import axios from "axios";
import authHeader from "@/services/auth-header";
import config from "@/data/config";
import Vue from "vue";

const API_URL = config.baseURL;

export const masterParoki = {
          namespaced: true,
          state: {
             data: {},
          },
          getters: {
             // countAll: (state) => {return state.data.length},
             countAll(state) {
                return state.data.length;
             }
          },
          actions: {
             getById({ commit, rootState }) {
                rootState.isLoading = true;
                axios.get(`${API_URL}paroki/item`, { headers: authHeader() }).then(
                   (response) => {
                      commit("SET_DATA", response.data);
                      rootState.isLoading = false;
                   },
                   () => {
                      rootState.isLoading = false;
                   }
                );
             },
             update({ rootState }, data) {
                rootState.isLoading = true;
                return axios
                   .put(`${API_URL}paroki/${data.id}`, data, {
                      headers: authHeader(),
                   })
                   .then(
                      (response) => {
                         rootState.isLoading = false;
                         Vue.$toast.success("Berhasil Disimpan");
                         return Promise.resolve(response);
                      },
                      (error) => {
                         rootState.isLoading = false;
                         Vue.$toast.success("Gagal Disimpan");
                         return Promise.reject(error);
                      }
                   );
             }
          },
          mutations: {
             SET_DATA(state, data) {
                state.data = data;
             },
             PUSH_ITEM(state, item) {
                state.data.push(item);
             },
          },
       };
